import { render, staticRenderFns } from "./ProccedToDashboardPage.vue?vue&type=template&id=c4993136&scoped=true"
import script from "./ProccedToDashboardPage.vue?vue&type=script&lang=js"
export * from "./ProccedToDashboardPage.vue?vue&type=script&lang=js"
import style0 from "./ProccedToDashboardPage.vue?vue&type=style&index=0&id=c4993136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4993136",
  null
  
)

export default component.exports